import React, { useState, useEffect } from 'react';
import GalleryDetailsTab from './Gallery/Gallery';
import { useSelector, useDispatch } from 'react-redux';
import Curriculum from './Curriculum/Curriculum';
import FeeStructure from './FeeStructure/FeeStructure';
import Infrastructure from './Infrastructure/Infrustructure';
import Management from './Management/Management';
import SelectableTags from '../../../../components/Forms/tags';
import styles from './viewDetailsBranch.module.css';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';
import BranchViewDetailsHeader from './header';
import { Box, Grid, makeStyles } from '@material-ui/core';
import useStyles from './styles';
import moment from 'moment';
import AboutDetails from './About/AboutDetails';
import {
  getAdmissionDatesAsync,
  getBranchDetails,
  getSessionAsync,
} from '../ManagementStore/managementStoreSlice';

const useLocalStyles = makeStyles({
  tagsContainer: {
    width: 'auto',
    minWidth: '15%',
    height: '2rem',
    marginRight: '5px',
    marginBottom: '8px',
  },
});

const ViewDetails = (props) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const localStyles = useLocalStyles();
  const [galleryView, setGalleryView] = useState(false);
  const [activeAbout, setActiveAbout] = useState(true);
  const [activeCurriculum, setActiveCurriculum] = useState(false);
  const [activeInfrustructure, setActiveInfrustructure] = useState(false);
  const [activeManagement, setActiveManagement] = useState(false);
  const [activeFee, setActiveFee] = useState(false);
  const [activeGallery, setActiveGallery] = useState(false);
  const [currentSessionId, setCurrentSessionId] = useState(null);

  const { schoolData, schoolSession } = useSelector((state) => {
    const { approvalManagementReducer } = state;
    return {
      schoolData: approvalManagementReducer && approvalManagementReducer.data,
      schoolSession:
        approvalManagementReducer && approvalManagementReducer.schoolSession,
    };
  });

  const location = useLocation();
  const branchUniqueId = location.search.split('=');

  useEffect(() => {
    dispatch(getBranchDetails(branchUniqueId[1]));
    if (branchUniqueId[1]) {
      dispatch(getSessionAsync({ schoolId: branchUniqueId[1] }));
    }
  }, []);

  useEffect(() => {
    if (
      Array.isArray(schoolSession) &&
      schoolSession.length > 0 &&
      branchUniqueId[1]
    ) {
      let currentYearStartDate = moment().startOf('year').toISOString();
      let nextYear = moment().add(1, 'years').format('YYYY');
      let nextYearEndDate = moment(nextYear).endOf('year').toISOString();
      schoolSession.forEach((item) => {
        let checkSessionStart = false;
        let checkSessionEnd = false;
        if (item.startDate) {
          checkSessionStart = moment(item.startDate).isSameOrAfter(
            currentYearStartDate
          );
        }
        if (item.endDate) {
          checkSessionEnd = moment(item.endDate).isSameOrBefore(
            nextYearEndDate
          );
        }
        if (checkSessionStart && checkSessionEnd) {
          setCurrentSessionId(item._id);
        }
      });
    }
  }, [schoolSession]);

  useEffect(() => {
    if (currentSessionId && branchUniqueId[1]) {
      dispatch(
        getAdmissionDatesAsync({
          schoolId: branchUniqueId[1],
          sessionId: currentSessionId,
        })
      );
    }
  }, [currentSessionId, branchUniqueId[1], schoolData]);

  return (
    <>
      {
        <div className={classes.container}>
          <div className={classes.containerHeader}>
            <div className={classes.innerContainer}>
              <BranchViewDetailsHeader
                {...{
                  styles: classes,
                  data: schoolData,
                  schoolId: branchUniqueId[1],
                  actions: {},
                }}
              />
            </div>
          </div>
          <Box className={styles.newViewDetailsTab}>
            <Box className={styles.viewDetailsNavHolder}>
              <a
                href="#about"
                onClick={() => {
                  setGalleryView(false);
                  setActiveCurriculum(false);
                  setActiveInfrustructure(false);
                  setActiveFee(false);
                  setActiveGallery(false);
                  setActiveAbout(true);
                  setActiveManagement(false);
                }}
                className={
                  activeAbout
                    ? styles.viewDetailsNav
                    : styles.viewDetailsNavInactive
                }>
                About
                {activeAbout ? (
                  <Box className={styles.activeBorderBottom}></Box>
                ) : null}
              </a>
            </Box>
            <Box className={styles.viewDetailsNavHolder}>
              <a
                href="#curriculum"
                onClick={() => {
                  setGalleryView(false);
                  setActiveAbout(false);
                  setActiveInfrustructure(false);
                  setActiveFee(false);
                  setActiveGallery(false);
                  setActiveCurriculum(true);
                  setActiveManagement(false);
                }}
                className={
                  activeCurriculum
                    ? styles.viewDetailsNav
                    : styles.viewDetailsNavInactive
                }>
                Curriculum
                {activeCurriculum ? (
                  <Box className={styles.activeBorderBottom}></Box>
                ) : null}
              </a>
            </Box>
            <Box className={styles.viewDetailsNavHolder}>
              <a
                href="#infrustructure"
                onClick={() => {
                  setGalleryView(false);
                  setActiveCurriculum(false);
                  setActiveAbout(false);
                  setActiveFee(false);
                  setActiveGallery(false);
                  setActiveInfrustructure(true);
                  setActiveManagement(false);
                }}
                className={
                  activeInfrustructure
                    ? styles.viewDetailsNav
                    : styles.viewDetailsNavInactive
                }>
                Infrastructure
                {activeInfrustructure ? (
                  <Box className={styles.activeBorderBottom}></Box>
                ) : null}
              </a>
            </Box>
            <Box className={styles.viewDetailsNavHolder}>
              <a
                href="#management"
                onClick={() => {
                  setGalleryView(false);
                  setActiveCurriculum(false);
                  setActiveAbout(false);
                  setActiveFee(false);
                  setActiveGallery(false);
                  setActiveInfrustructure(false);
                  setActiveManagement(true);
                }}
                className={
                  activeManagement
                    ? styles.viewDetailsNav
                    : styles.viewDetailsNavInactive
                }>
                Management
                {activeManagement ? (
                  <Box className={styles.activeBorderBottom}></Box>
                ) : null}
              </a>
            </Box>
            <Box className={styles.viewDetailsNavHolder}>
              <a
                href="#fee"
                onClick={() => {
                  setGalleryView(false);
                  setActiveCurriculum(false);
                  setActiveInfrustructure(false);
                  setActiveAbout(false);
                  setActiveGallery(false);
                  setActiveFee(true);
                  setActiveManagement(false);
                }}
                className={
                  activeFee
                    ? styles.viewDetailsNav
                    : styles.viewDetailsNavInactive
                }>
                Fee Structure
                {activeFee ? (
                  <Box className={styles.activeBorderBottom}></Box>
                ) : null}
              </a>
            </Box>
            <Box className={styles.viewDetailsNavHolder}>
              <a
                href="#"
                onClick={() => {
                  setGalleryView(true);
                  setActiveCurriculum(false);
                  setActiveInfrustructure(false);
                  setActiveFee(false);
                  setActiveAbout(false);
                  setActiveGallery(true);
                  setActiveManagement(false);
                }}
                className={
                  activeGallery
                    ? styles.viewDetailsNav
                    : styles.viewDetailsNavInactive
                }>
                Gallery
                {activeGallery ? (
                  <Box className={styles.activeBorderBottom}></Box>
                ) : null}
              </a>
            </Box>
          </Box>
          <Box className={classes.solidBorderBottom}></Box>

          {schoolData ? (
            galleryView ? (
              <div>
                {schoolData ? (
                  <GalleryDetailsTab
                    {...{
                      styles: classes,
                      data: {
                        images: schoolData.image,
                        schoolId: branchUniqueId[1],
                      },
                    }}
                  />
                ) : null}
              </div>
            ) : (
              <Grid
                container
                spacing={3}
                className={classes.viewDetailsSectionContainer}>
                <Grid item xs={8}>
                  <Box>
                    <Box id="about" style={{ marginBottom: '3%' }}>
                      {schoolData ? (
                        <AboutDetails
                          {...{
                            styles: classes,
                            data: schoolData,
                            schoolIdParam: branchUniqueId[1],
                          }}
                        />
                      ) : null}
                    </Box>
                    <Box id="curriculum" style={{ marginBottom: '3%' }}>
                      <Curriculum
                        {...{
                          styles: classes,
                          data: schoolData,
                        }}
                      />
                    </Box>
                    <Box id="infrustructure" style={{ marginBottom: '3%' }}>
                      <Infrastructure
                        {...{
                          styles: classes,
                          data: schoolData,
                        }}
                      />
                    </Box>
                    <Box id="fee" style={{ marginBottom: '3%' }}>
                      <FeeStructure
                        {...{
                          styles: classes,
                          data: schoolData,
                        }}
                      />
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={4}>
                  {schoolData.infrastructure ? (
                    <div className={classes.sectionContainer}>
                      <p className={classes.sectionText}>Facilities</p>
                      <p>Amenities</p>
                      <Grid container justify="space-between" spacing={2}>
                        <SelectableTags
                          {...{
                            styles: localStyles,
                            data: {
                              values: schoolData.infrastructure.general,
                            },
                            isClickable: false,
                          }}
                        />
                      </Grid>
                      <p className={classes.facilitiesPad}>Labs</p>
                      <Grid container justify="space-between" spacing={2}>
                        <SelectableTags
                          {...{
                            styles: localStyles,
                            data: {
                              values: schoolData.infrastructure.academics,
                            },
                            isClickable: false,
                          }}
                        />
                      </Grid>
                      <p className={classes.facilitiesPad}>Sports</p>
                      <Grid container justify="space-between" spacing={2}>
                        <SelectableTags
                          {...{
                            styles: localStyles,
                            data: {
                              values: schoolData.infrastructure.sports,
                            },
                            isClickable: false,
                          }}
                        />
                      </Grid>
                    </div>
                  ) : null}
                  {schoolData.curriculumDetails ? (
                    <div className={classes.sectionContainer}>
                      <p className={classes.sectionText}>Curriculum</p>
                      <Grid container justify="space-between" spacing={2}>
                        <SelectableTags
                          {...{
                            styles: localStyles,
                            data: {
                              values:
                                schoolData.curriculumDetails.curriculumTags,
                            },
                            isClickable: false,
                          }}
                        />
                      </Grid>
                    </div>
                  ) : null}
                  <Box id="management" className={classes.sectionContainer}>
                    <p className={classes.sectionText}>
                      Words from our management
                    </p>
                    <Box>
                      <Management
                        {...{
                          styles: classes,
                          data: schoolData,
                        }}
                      />
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            )
          ) : null}
        </div>
      }
    </>
  );
};

export default ViewDetails;
